export var GLOBAL = {
    nombreMuni: 'Puente Alto',//
    /*  url: 'http://localhost:3988/api/v1/',
     urlSocket: 'http://localhost:3989', */

    url: 'https://nidx.solnet.cl:3988/api/v1/',
    urlSocket: 'https://nidx.solnet.cl:3989',

    //url: 'https://nidx.solnet.cl:3908/api/v1/', // public-prod

    //pdfUrl: 'http://download.localhost:3420/api/v1/download',//este funciona
    pdfUrl: 'http://nidx.solnet.cl:3908/api/v1/download',
    region: 'REGIÓN METROPOLITANA',

    filedomSolicitudUrl: 'http://puentealto.filedom.cl/', //solicitud certificados
    filedomSeguimientoUrl: 'http://puentealto.filedom.cl/seguimiento_certificados',//seguimientos certificados
    seguimientoSolicitudes: 'http://puentealto.filedom.cl/seguimiento_solicitudes',
    seguimientoCertificados: false,
    totemUrl: 'http://puentealto.filedom.cl/autoatencion/',
    footer: 'Puente Alto - Av. Concha y Toro 1820, Puente Alto',
    webUrl: 'https://www.mpuentealto.cl/',
    web: 'www.mpuentealto.cl',
    acotado: true,

    mapasUrl: 'http://',
    comunaMapa: "", //"la%20florida"
    //footer: 'MUNICIPALIDAD DE COLINA -  Dirección de Obras Av. Colina 700 Colina, Provincia de Chacabuco, R. Metropolitana',

    docAccept: ".jpg,.png,.DWG,.dwg,.pdf,.docx,.doc,.xls,.xlsx",
    correos: ["correodeprueba@solnet.cl", "correodeprueba2@solnet.cl"],

    pruebaPrototipo: true,
    generico: true,



}
